import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const Badge = ({ product }) => {
  const [currentVariant, setCurrentVariant] = useState(
    product.variants.find(
      (v) =>
        JSON.stringify(v.selectedOptions) ===
        JSON.stringify(product.variantBySelectedOptions.selectedOptions),
    ),
  );

  const handleCurrentVariantUpdated = (e) => {
    const { currentProductData } = e.detail;
    setCurrentVariant(currentProductData.variants.find(
      (v) =>
        JSON.stringify(v.id) ===
        JSON.stringify(e.detail.currentVariant),
    ));
  };

  useEffect(() => {
    document.addEventListener("currentVariantUpdated", handleCurrentVariantUpdated);
    return () => document.removeEventListener('currentVariantUpdated', handleCurrentVariantUpdated);
  }, []);

  return (
    currentVariant?.badge && (
      <div className='absolute left-2 md:px-1.5 px-1 top-2 rounded-sm bg-black z-10 text-white utility-3 inline-flex items-center justify-center h-4 md:h-5 !font-[400] !tracking-sml !text-11'>
        {currentVariant.badge}
      </div>
    )
  );
};

export default Badge;
